export type LangCode =
  | "en" | "zh" | "hi" | "es" | "fr" | "ar" | "bn" | "pt" | "ru" | "ur"
  | "id" | "de" | "ja" | "sw" | "mr" | "te" | "tr" | "ta" | "vi" | "ko"
  | "it" | "th" | "pl" | "uk" | "fa" | "ro" | "nl" | "el" | "cs" | "hu"
  | "sv" | "he" | "da" | "fi" | "no" | "ms";

export interface LanguageMeta {
  code: LangCode;
  name: string;        // English name
  native: string;      // Native name
  flag: string;        // emoji flag
  dir: "ltr" | "rtl";
}

export const LANGUAGES: LanguageMeta[] = [
  { code: "en", name: "English",    native: "English",      flag: "🇬🇧", dir: "ltr" },
  { code: "zh", name: "Chinese",    native: "中文",          flag: "🇨🇳", dir: "ltr" },
  { code: "hi", name: "Hindi",      native: "हिन्दी",         flag: "🇮🇳", dir: "ltr" },
  { code: "es", name: "Spanish",    native: "Español",      flag: "🇪🇸", dir: "ltr" },
  { code: "fr", name: "French",     native: "Français",     flag: "🇫🇷", dir: "ltr" },
  { code: "ar", name: "Arabic",     native: "العربية",      flag: "🇸🇦", dir: "rtl" },
  { code: "bn", name: "Bengali",    native: "বাংলা",          flag: "🇧🇩", dir: "ltr" },
  { code: "pt", name: "Portuguese", native: "Português",    flag: "🇵🇹", dir: "ltr" },
  { code: "ru", name: "Russian",    native: "Русский",      flag: "🇷🇺", dir: "ltr" },
  { code: "ur", name: "Urdu",       native: "اردو",          flag: "🇵🇰", dir: "rtl" },
  { code: "id", name: "Indonesian", native: "Bahasa Indonesia", flag: "🇮🇩", dir: "ltr" },
  { code: "de", name: "German",     native: "Deutsch",      flag: "🇩🇪", dir: "ltr" },
  { code: "ja", name: "Japanese",   native: "日本語",         flag: "🇯🇵", dir: "ltr" },
  { code: "sw", name: "Swahili",    native: "Kiswahili",    flag: "🇰🇪", dir: "ltr" },
  { code: "mr", name: "Marathi",    native: "मराठी",          flag: "🇮🇳", dir: "ltr" },
  { code: "te", name: "Telugu",     native: "తెలుగు",         flag: "🇮🇳", dir: "ltr" },
  { code: "tr", name: "Turkish",    native: "Türkçe",       flag: "🇹🇷", dir: "ltr" },
  { code: "ta", name: "Tamil",      native: "தமிழ்",          flag: "🇮🇳", dir: "ltr" },
  { code: "vi", name: "Vietnamese", native: "Tiếng Việt",   flag: "🇻🇳", dir: "ltr" },
  { code: "ko", name: "Korean",     native: "한국어",         flag: "🇰🇷", dir: "ltr" },
  { code: "it", name: "Italian",    native: "Italiano",     flag: "🇮🇹", dir: "ltr" },
  { code: "th", name: "Thai",       native: "ไทย",           flag: "🇹🇭", dir: "ltr" },
  { code: "pl", name: "Polish",     native: "Polski",       flag: "🇵🇱", dir: "ltr" },
  { code: "uk", name: "Ukrainian",  native: "Українська",   flag: "🇺🇦", dir: "ltr" },
  { code: "fa", name: "Persian",    native: "فارسی",         flag: "🇮🇷", dir: "rtl" },
  { code: "ro", name: "Romanian",   native: "Română",       flag: "🇷🇴", dir: "ltr" },
  { code: "nl", name: "Dutch",      native: "Nederlands",   flag: "🇳🇱", dir: "ltr" },
  { code: "el", name: "Greek",      native: "Ελληνικά",     flag: "🇬🇷", dir: "ltr" },
  { code: "cs", name: "Czech",      native: "Čeština",      flag: "🇨🇿", dir: "ltr" },
  { code: "hu", name: "Hungarian",  native: "Magyar",       flag: "🇭🇺", dir: "ltr" },
  { code: "sv", name: "Swedish",    native: "Svenska",      flag: "🇸🇪", dir: "ltr" },
  { code: "he", name: "Hebrew",     native: "עברית",         flag: "🇮🇱", dir: "rtl" },
  { code: "da", name: "Danish",     native: "Dansk",        flag: "🇩🇰", dir: "ltr" },
  { code: "fi", name: "Finnish",    native: "Suomi",        flag: "🇫🇮", dir: "ltr" },
  { code: "no", name: "Norwegian",  native: "Norsk",        flag: "🇳🇴", dir: "ltr" },
  { code: "ms", name: "Malay",      native: "Bahasa Melayu", flag: "🇲🇾", dir: "ltr" },
];

export const LANG_BY_CODE: Record<string, LanguageMeta> = LANGUAGES.reduce(
  (acc, l) => { acc[l.code] = l; return acc; },
  {} as Record<string, LanguageMeta>
);

export const RTL_CODES = LANGUAGES.filter(l => l.dir === "rtl").map(l => l.code);